import { connect } from 'react-redux';
import { getReplacementDates } from '../../../states/calendar/selectors';
import { goBackAfterDeadlineMissed, acceptDateChangeAndResubmit } from '../../../states/chaps/actions';
import { fetchCalendar } from '../../../states/calendar/actions';
import { resetApp } from '../../../states/page/actions';
import { hasApiCallInProgress } from '../../../states/api/selectors';
import DeadlineMissedModal from '../../../sharedComponents/DeadlineMissedModal/DeadlineMissedModal';
import { calendarTypes } from '../../../config';

const mapState = (state) => ({
	hasApiCallInProgress: hasApiCallInProgress(state),
	replacementDates: getReplacementDates(state),
});

const mapDispatch = (dispatch) => ({
	acceptDateChangeAndResubmit: () => dispatch(acceptDateChangeAndResubmit),
	goBackAfterDeadlineMissed: ({ submission }) => dispatch(goBackAfterDeadlineMissed(submission)),
	resetApp: () => {
		dispatch(resetApp);
		dispatch(fetchCalendar(calendarTypes.CALENDAR_TYPE_CHAPS));
	},
});

export default connect(mapState, mapDispatch)(DeadlineMissedModal);
